import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/styles";
import { CardHeader, Divider, Grid, Button } from "@material-ui/core";
import ViewQuiltIcon from "@material-ui/icons/ViewQuilt";
import { IsEmpty } from "../../../../utils/helper";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    height: "100%",
    borderRadius: 10,
    marginBottom: 40,
  },
  image: {
    border: "1px solid #E1E1E1",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: 350,
    width: "99%",
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 20,
    marginTop: 5,
    width: "30%",
  },
  imgTitle: {
    fontWeight: 700,
    color: "#3f51b5",
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "93%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 15,
    marginBottom: 10,
  },
  cardContent: {
    flexGrow: 1,
    padding: 10,
    overflow: "auto",
  },
  imageContainer: {
    flexGrow: 1,
    margin: 10,
  },
  imagePageNo: {
    backgroundColor: "#d9d8d8",
    fontSize: 35,
    fontWeight: 600,
    marginRight: 4,
  },
});

class OrderTab extends React.Component {
  render() {
    const { classes } = this.props;
    let imageContainerHeight = window.screen.height - 380;
    return (
      <React.Fragment>
        <Card className={classes.card}>
          <CardHeader
            style={{ padding: 11 }}
            title={
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span className={classes.title}>
                  <ViewQuiltIcon className={classes.titleIcon} />
                  <b>Images</b>
                </span>
                <div
                  style={{
                    display: "inline-flex",
                    width: "70%",
                    justifyContent: "end",
                    marginRight: 10,
                  }}
                >
                  <Button
                    onClick={() => this.props.printBarcode()}
                    disabled={
                      this.props.values.imagesDataLoading ||
                      this.props.values.isDownloadImages ||
                      IsEmpty(this.props.values.selectedSalesData)
                    }
                    style={{
                      textDecoration: "underline",
                      fontSize: 12,
                      padding: 3,
                      textTransform: "capitalize",
                      cursor: `${this.props.values.isDownloadImages
                          ? "waiting"
                          : "pointer"
                        }`,
                    }}
                    color="primary"
                  >
                    {this.props.values.barcodeDataLoading ? (
                      <CircularProgress size={16} />
                    ) : (
                      "Print Barcode"
                    )}
                  </Button>
                </div>
              </div>
            }
          />
          <Divider className={classes.titleDivider} />
          <CardContent style={{ padding: 0, overflow: "auto", height: "100%" }}>
            <div className={classes.imageContainer}>
              {this.props.values.imagesDataLoading ? (
                <div>
                  <CircularProgress />
                </div>
              ) : (
                <Grid container spacing={1}>
                  {this.props.values.imagesData.map((card, index) => {
                    if (!card.id) {
                      return <CardContent className={classes.cardContent} />;
                    } else {
                      return (
                        <Fragment key={card.id || index}>
                          <Fragment>
                            <Grid item xs={12}>
                              <div className={classes.imagePageNo}>
                                {card.pageNoLabel}
                              </div>
                              <div
                                onClick={() => this.props.onImageClick(card)}
                                className={classes.image}
                                style={{
                                  backgroundImage: `url('${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${card.thumnailFileName}')`,
                                  height: imageContainerHeight,
                                  cursor: "pointer",
                                }}
                              />
                            </Grid>
                          </Fragment>
                        </Fragment>
                      );
                    }
                  })}
                </Grid>
              )}
            </div>
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

OrderTab.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  onImageClick: PropTypes.func,
  downloadImagesData: PropTypes.func,
  downloadPdfImagesData: PropTypes.func,
  printBarcode: PropTypes.func,
};

OrderTab.defaultProps = {
  values: {},
  onImageClick: (fn) => fn,
  downloadImagesData: (fn) => fn,
  downloadPdfImagesData: (fn) => fn,
  printBarcode: (fn) => fn,
};

export default withStyles(useStyles)(OrderTab);
